import { Component, ElementRef, Input, NgZone, ViewChild } from '@angular/core';
import { ModalConfig } from '../../modal-config';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { CountryService } from 'src/app/_services/country.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ParentService } from 'src/app/user-management/_services/parent.service';
import { SnackbarService } from 'src/app/_services/snackBar.service';
import { SnackBarErrorComponent } from 'src/app/components/snack-bar-error/snack-bar-error.component';
import { StudentService } from 'src/app/user-management/_services/student.service';
import { GradeService } from 'src/app/school-management/_services/grades.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ControlQrService } from 'src/app/_services/control-qr.service';
import { ControlActivationService } from 'src/app/_services/control-activation.service';
import { ModalService } from '../../modal.service';
declare var $: any;

@Component({
  selector: 'app-parent-modal',
  templateUrl: './parent-modal.component.html',
  styleUrls: ['./parent-modal.component.scss']
})
export class ParentModalComponent {
  @Input() config!: ModalConfig;
  @Input() lang: string;
  // the modal's own file input — never look it up by id, other components on the
  // same page use the same id and getElementById would hand us theirs
  @ViewChild('fileUploadInput') fileUploadInput: ElementRef<HTMLInputElement>;
  addParentForm: UntypedFormGroup;


  latitude: number;
  longitude: number;
  address: string;
  mapControls;
  mapView = '';

  countries = [];
  relatedStudents = [];
  kids = [];
  helpers = [];
  permittedUsers = [];

  completedProfile: boolean;
  parent;
  parentId: number;
  parentName: string;
  parentActivation: boolean;

  imageFile;
  selectedImage;
  image;

  showedNumber:number;

  // a verified parent owns the number they verified, so the phone is locked
  get parentVerified(): boolean {
    return this.isFlagOn(this.config?.data?.is_verified);
  }

  // the parent verified one specific number: the tick only holds while the
  // field still shows it, so clearing or editing the phone drops it
  get phoneVerified(): boolean {
    if (!this.parentVerified) {
      return false;
    }
    const phone = this.addParentForm?.get('phone')?.value;
    const code = this.addParentForm?.get('country_code')?.value;
    return !!phone
      && this.sameValue(phone, this.config?.data?.phone)
      && this.sameValue(code, this.config?.data?.country_code);
  }

  private sameValue(a: any, b: any): boolean {
    return String(a ?? '').trim() === String(b ?? '').trim();
  }

  // the flags come back as 1/0 from the API but as booleans from some mappers
  private isFlagOn(value: any): boolean {
    return value === 1 || value === true;
  }

  constructor(
    // private mapsAPILoader: MapsAPILoader,
    private _snackBar: MatSnackBar,
    private ngZone: NgZone,
    private dataService: DataService,
    private countryService: CountryService,
    private translate: TranslateService,
    private parentService: ParentService,
    private snackbarService: SnackbarService,
    private studentService: StudentService,
    private gradesService: GradeService,
    private globalService: GlobalService,
    private qrControl: ControlQrService,
    private controlActivation: ControlActivationService,
    private modalService:ModalService
  ) { }

  ngOnInit() {
    console.log('addStudentConfig', this.config);
    console.log('addStudentLang', this.lang);
    this.setMapView('init');
    // lat long of school
    this.initLatLng();
    this.initFormFields();
    this.getCountries();
    if (this.config.mode != 'add') {
      this.setEditValues();
    }
    this.dataService.getRowsNumberShown().subscribe(res => {
      this.showedNumber = res
    })
  }

  initFormFields() {
    this.addParentForm = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required]),
      national_id: new UntypedFormControl('', [Validators.required, Validators.pattern('[a-zA-Z0-9]*')]),
      gender: new UntypedFormControl(''),
      type: new UntypedFormControl('', Validators.required),
      country_code: new UntypedFormControl('', Validators.required),
      phone: new UntypedFormControl('', [Validators.required]),
      email: new UntypedFormControl('', [Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')])
    })
  }

  setEditValues() {
    if (this.config?.data) {
      this.parent = this.config?.data;
      this.image = environment.img_url + this.config?.data?.image_path;
      this.completedProfile = this.config?.data?.is_completed_profile === 1 ? true : false;
      this.parentId = this.config?.data?.id;
      this.parentName = this.config?.data?.name;
      this.parentActivation = this.config?.data?.schools?.[0]?.pivot?.is_active === 1 ? true : false;
      this.relatedStudents = this.config?.data?.students;
      this.helpers = this.config?.data?.helpers;

      for (const i in this.addParentForm?.value) {
        this.addParentForm.controls[i].setValue(this.config?.data[i])
      }
      this.addParentForm?.controls['country_code'].setValue(this.config?.data?.country_code)
      this.addParentForm?.controls['phone'].setValue(this.config?.data?.phone)
      this.addParentForm?.controls['email'].setValue(this.config?.data?.email)
      this.config?.data?.gender == "male" ? this.addParentForm?.controls.type.setValue('father') :
        this.addParentForm?.controls.type.setValue('mother');
      // if(this.completedProfile){
      //   this.addParentForm.get('country_code').disable();
      // }
      this.mapKidsArray(this.relatedStudents);
      this.mapHelpersArray(this.helpers);
    }
  }

  setMapView(viewCycle) {
    this.mapView = viewCycle == 'init' ? 'add-parent' : 'add-parent-destroyed';
  }

  initLatLng() {
    this.latitude = this.config?.data?.lat ? this.config?.data?.lat : null;
    this.longitude = this.config?.data?.long ? this.config?.data?.long : null;
    this.address = this.config?.data?.address;
    this.initMapControls();
  }

  initMapControls() {
    this.mapControls = {
      mapPoint: {
        lat: this.latitude,
        long: this.longitude,
      }
    }
  }

  getCountries() {
    this.countries = this.countryService.countries;
  }

  getValidationError(control: string) {
    let errorMSG;
    if (this.addParentForm.controls[control].errors) {
      switch (control) {
        case 'name':
          errorMSG = this.addParentForm.controls[control].errors.required ? this.translate.instant('edit-parent.name-required') :
            this.addParentForm.controls[control].errors.repeat ? this.translate.instant('edit-parent.name-exists')
              : this.translate.instant('edit-parent.name-valid');
          break;
        case 'national_id':
          errorMSG = this.addParentForm.controls[control].errors.required ? this.translate.instant('edit-parent.id-required') :
            this.addParentForm.controls[control].errors.repeat ? this.translate.instant('edit-parent.id-exists')
              : this.translate.instant('edit-parent.id-valid');
          break;

        case 'phone':
          errorMSG = this.addParentForm.controls[control].errors.required ? this.translate.instant('edit-parent.phone-required') :
            this.addParentForm.controls[control].errors.repeat ? this.translate.instant('edit-parent.phone-exists')
              : this.translate.instant('edit-parent.phone-valid');
          break;

        case 'email':
          errorMSG = this.addParentForm.controls[control].errors.required ? this.translate.instant('edit-parent.email-required') :
            this.addParentForm.controls[control].errors.repeat ? this.translate.instant('edit-parent.email-exists')
              : this.translate.instant('edit-parent.email-valid');
          break;
        default:
          break;
      }
    }
    return errorMSG;
  }

  getImage(url) {
    return environment.img_url + url;
  }

  changeParentProfile() {
    const fileUpload = this.fileUploadInput?.nativeElement;
    if (!fileUpload) {
      return;
    }
    // clearing the value first so re-picking the same file still fires `change`
    fileUpload.value = null;
    fileUpload.click();
  }

  onFileSelected(file: FileList) {
    const picked = file?.item(0);
    if (!picked) {
      return;
    }
    // the upload payload and the preview are set together, so they can never diverge
    this.imageFile = picked;
    this.selectedImage = picked;
    const reader = new FileReader();
    reader.onload = (event: any) => {
      this.image = event.target.result;
    };
    reader.readAsDataURL(picked);
  }

  showQR() {
    this.qrControl.setParentData(this.parent, 'single');
    $('#qrModal').modal("show");
  }

  regenerateQR() {
    this.qrControl.setRegenerateUserData(this.parent);
    $('#confirmModal').modal('show');
  }


  // same effect the map's own clear button used to have
  clearAddress() {
    this.address = '';
    this.latitude = null;
    this.longitude = null;
  }

  mapEventHandle(event) {
    switch (event.type) {
      case "updateAdress":
        this.address = event.data;
        this.latitude = event.lat;
        this.longitude = event.lng;
        break;
    }
  }

  changeActivation() {
    let body = { 'noOfShownRows': this.showedNumber, 'type': '', 'userName': this.parentName, 'userId': this.parentId, 'state': !this.parentActivation, 'event': '' }
    this.controlActivation.setToggledUSer(body);
    $("#confirmModal").modal("show");
  }


  sanitizeDataBeforeSendToServer(): void {
    let parentGender = this.addParentForm.get('gender');    
    
    if ((parentGender.value as string)?.trim() === '' || parentGender.value == "noParentGender" ||  parentGender.value == null ) {
      delete this.addParentForm.value['gender'];
    }
} 

  // add student
  saveParent() {
    this.sanitizeDataBeforeSendToServer();
    const formData = new FormData();
    if (this.imageFile) {
      formData.append('image', this.imageFile);
    }
    for (const i in this.addParentForm.value) {
      formData.append(i, this.addParentForm.value[i])
    }
      formData.append('lat', this.latitude != null ? this.latitude.toString() : '');
      formData.append('long', this.longitude != null ? this.longitude.toString() : '');
      formData.append('address', this.address || '');

    // updating parent
    this.parentService.updateParent(this.parentId, formData).subscribe(res => {
      this.updateAllUsersObservable();
      this.closeModalHandler();
    },
      (error) => {
        Object.keys(error.error.errors).map(element => {
          this.addParentForm.controls[element].setErrors({ 'repeat': true });
          this.addParentForm.controls[element].markAsTouched();
        })
      })
  }

  updateAllUsersObservable(){
    this.dataService.getUsers$().subscribe(res=>{
      this.dataService.setUsers$(res);
    })
  }

  
  // a student can sit in a class that has no grade yet, so every hop has to be
  // optional: one throw here used to abort the map and leave the panel reading
  // "no students linked" for a parent that has them
  mapKidsArray(kidsArray: any) {
    this.kids = (kidsArray || []).map(kid => (
      {
        student_image: kid?.image_path,
        name: kid?.name,
        grade: kid?.class?.grade?.name,
        class: kid?.class?.name,
        national_id: kid?.national_id,
        id: kid?.id,
        is_active: kid?.pivot?.pick_type,
        // the link flag rides on the student, or on the pivot that ties them here
        is_verified_parent_link: this.isFlagOn(kid?.is_verified_parent_link ?? kid?.pivot?.is_verified_parent_link)
      }
    ));
  }

  mapHelpersArray(helpersArray:any){
    let role = this.lang == 'en' ? "Primary" : "أساسي"
    this.permittedUsers = (helpersArray || []).map(helper => (
      {
        helper_image: helper?.image_path,
        name: helper?.name,
        national_id: helper?.national_id,
        role:role
      }
    ));
  }

  closeModalHandler(){
    this.dataService.setRowsNumberShown(this.showedNumber);
    this.modalService.closeModal();
  }
}
